var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"docs"},[_c('h1',{staticClass:"title"}),_c('div',{staticClass:"details"},[_vm._v("\n    发的发的发发发的说法打发大水发生\n  ")])])}]

export { render, staticRenderFns }